import React from 'react'

import {colors} from "../../utils/styles"
import {merge} from "../../utils/util"

export const iconSpanStyle = {
  height: 15,
  paddingRight: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'right'
}

export class DigitalCheckBox extends React.Component {

  getEnabled() {
    const enabled = this.props.isEnabled
    if (enabled === undefined) {
      return true
    }
    return enabled
  }

  handleClick() {
    if (this.getEnabled()) {
      const event = {target: {value: !this.props.isChecked}}
      this.props.handleClick(event)
    }
  }

  render() {
    let style = {display: 'flex', padding: '4px 0px 4px 0px'}
    if (this.props.style) {
      style = merge(style, this.props.style)
    }
    const {isChecked, label, group} = this.props

    return (
        <div className={this.props.classNameToUse || group + "-" + label}
             style={style}
             onClick={this.handleClick.bind(this)}>
        <span style={iconSpanStyle}>
          <img src={(isChecked ? 'images/moc-gray-check.svg' : 'images/moc-checkmark-empty.svg')}
               style={{opacity: this.getEnabled() ? 1.0 : 0.5}}
               alt="check"
          />
        </span>
          <span style={{
            fontSize: '14px',
            fontWeight: 400,
            color: colors.mocText
          }}>
          {label}
        </span>
        </div>
    )
  }
}